module.exports = __webpack_public_path__ + "img/matkailukartta-bg.8e47cba0.svg";